// Intro copy. Change the role here rather than editing page markup.
export const site = {
  introTitle: "Welcome to Oliver's Portfolio",
  role: 'Associate software engineer @ SIE',
  enterLabel: 'begin',
};
